<template>
  <b-modal ref="mdlConfigurazioneMagazzinoUmArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc
    hide-header-close size="lg">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label class="sa-label-data">Codice Azienda</label>
        <b-form-select v-model="localData.codiceAzienda">
          <template #first>
            <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
          </template>
          <b-form-select-option v-for="item in strutturaOptions" :key="item.id" :value="item.codiceStruttura"><span>{{
            `${item.denominazione} (${item.codiceStruttura}) ` }}</span></b-form-select-option>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label class="sa-label-data">U.M</label>
        <span v-if="isReadOnly"> {{ localData.descrizioneMultiplo }}</span>
        <b-form-input v-else v-model="localData.descrizioneMultiplo"></b-form-input>
      </b-col>

      <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
        <label class="sa-label-data">Codice U.M</label>
        <span v-if="isReadOnly">{{ localData.codiceMoltiplicatore }}</span>
        <b-form-input v-else v-model="localData.codiceMoltiplicatore" type="text"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
        <label class="sa-label-data">Multiplo</label>
        <span v-if="isReadOnly">{{ localData.multiplo }}</span>
        <b-form-input v-else v-model="localData.multiplo"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label class="sa-label-data">U.M Base</label>
        <b-form-select v-model="localData.umBaseId" @change="onChangeUmBaseId">
          <template #first>
            <b-form-select-option :value="null"> Nessuna </b-form-select-option>
          </template>
          <b-form-select-option v-for="item in getMisureBaseUM" :key="item.id" :value="item.id"><span>{{
            `${item.descrizioneMultiplo}` }}</span></b-form-select-option>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
        <label class="sa-label-data">Codice U.M</label>
        <b-form-input :disabled="true" v-model="baseUmSelezionato.codiceMoltiplicatore" type="text"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
        <label class="sa-label-data">Multiplo</label>
        <b-form-input :disabled="true" v-model="baseUmSelezionato.multiplo"></b-form-input>
      </b-col>
    </b-row>

    <template #modal-footer>
      <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
      <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaUmArticolo">Salva</b-button>
      <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
    </template>
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
export default {
  mixins: [UtilityMixin, StruttureMixin, MagazzinoMixins],
  components: { ModalError },
  data() {
    return {
      title: null,
      isReadOnly: false,
      pathResource: "/magazzinoarticolium",
      localData: {
        id: null,
        codiceAzienda: null,
        descrizioneMultiplo: null,
        multiplo: 0,
        codiceMoltiplicatore: null,
        umBaseId: null,
      },
      baseUmSelezionato: {},
    };
  },
  props: {
    jsonData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  computed: {
    getMisureBaseUM() {
      let returnValue = [];

      if (this.magazzinoArticoliUnitaMisuraOptions[0]) {
        this.magazzinoArticoliUnitaMisuraOptions.forEach((element) => {
          if (!element.umBaseId) {
            returnValue.push(element);
          }
        });
      }

      return returnValue;
    },
  },

  mounted() {
    this.struttureLoadData();
    this.mangazzinoArticoliUnitaMisuraLoadData();
  },
  methods: {
    show(jsonData, isReadOnly) {
      let me = this;
      me.localData = jsonData;
      me.isReadOnly = isReadOnly;
      if (me.jsonData) {
        this.localData.codiceAzienda = me.jsonData.codiceAzienda;
      }
      if (isReadOnly) {
        me.title = "Visualizzazione Unità di Misura";
      } else {
        me.title = !jsonData.id ? "Nuova Unità di Misura" : "Aggiorna Unità di Misura";
      }
      me.$refs.mdlConfigurazioneMagazzinoUmArticoli.show();
    },

    onClickSalvaUmArticolo() {
      let me = this;

      UtilityMixin.methods.saveResource(me.pathResource, me.localData, me.salvaUmArticoloSuccess, me.salvaUmArticoloError);
    },
    onChangeUmBaseId(valore) {
      if (valore) {
        let misuraBase = this.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.codiceAzienda == this.localData.codiceAzienda && e.descrizioneMultiplo == valore);
        if (misuraBase[0]) {
          this.baseUmSelezionato = misuraBase[0];
        }
      }
    },
    salvaUmArticoloSuccess(response) {
      let me = this;
      me.$emit("saveUmArticolo", response);
      me.$refs.mdlConfigurazioneMagazzinoUmArticoli.hide();
      me.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    salvaUmArticoloError(error) {
      let me = this;
      me.$emit("saveUmArticolo", error);
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },

    onDeleteUmArticolo(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questa configurazione?", {
          title: "Eliminazione U.M",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteUmArticolo(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteUmArticolo(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteUmArticoloSuccess, me.deleteUmArticoloError);
    },
    deleteUmArticoloSuccess(response) {
      let me = this;
      me.$emit("umArticoloDelete", response);
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    deleteUmArticoloError(response) {
      let me = this;
      me.$emit("umArticoloDelete", response);
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },

    onCloseModal() {
      let me = this;
      me.localData = {
        id: null,
        codiceAzienda: null,
        descrizioneMultiplo: null,
        multiplo: 0,
        codiceMoltiplicatore: null,
        umBaseId: null,
      };
      me.$emit("onCloseModal");
      me.$refs.mdlConfigurazioneMagazzinoUmArticoli.hide();
    },
  },
};
</script>
